import { HttpClient } from '@angular/common/http';
import { ElementRef } from '@angular/core';
import { SECTOR_DISPLAY_NAMES } from '../constants';
import { STATIC_PDF_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { AS_OF_DATE_CUSTOM, AS_OF_DATE_DAILY, AS_OF_DATE_DROPDOWN_CONFIG, } from 'SecuritiesApp/ts/constants/attribution.constants';
import { Language } from 'NewAngular/enums/language.enum';
import { AttributionBenchmarkOption, AttributionCategorization, PerformancePeriodicity, } from 'SecuritiesApp/ts/interfaces/attribution.interface';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { SecuritiesService } from 'SecuritiesApp/ts/services/securities.service';
import { PdfTitleModalComponent } from 'NewAngular/features/components/pdf-title-modal/pdf-title-modal.component';
import { formatDateString } from 'Core/redesign/utils/date';
import { downloadUrl } from 'NewAngular/utils/download';
import { getFormatter } from 'NewAngular/utils/number_formatter';
import { isPeriodicityDisabled } from 'SecuritiesApp/ts/features/attribution-relative/utils';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "SecuritiesApp/ts/services/securities.service";
import * as i4 from "@angular/common/http";
import * as i5 from "../../../../../../../search/static/search/ts/features/autocomplete-in-place/security-autocomplete-in-place.component";
import * as i6 from "../../../../../../../../ycharts/static/ts/features/directives/disabled/disabled.directive";
import * as i7 from "../../../../../../../../ycharts/static/ts/features/components/modals/help-modal/components/help-modal.component";
import * as i8 from "../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i9 from "NewAngular/features/components/modals/loading-modal/loading-modal.component";
import * as i10 from "NewAngular/features/components/pdf-title-modal/pdf-title-modal.component";
import * as i11 from "../../../../../../../../ycharts/static/ts/features/components/date-controls/single-date-picker/single-date-picker.component";
import * as i12 from "../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i13 from "../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i14 from "./attribution-bar-chart/attribution-bar-chart.component";
import * as i15 from "./attribution-performance-chart/attribution-performance-chart.component";
import * as i16 from "./attribution-relative-table/attribution-relative-table.component";
const _c0 = ["pdfTitleModal"];
const _c1 = () => ({ button: "btn btn-secondary dropdown-toggle width-180 d-flex justify-content-between", dropdownContainer: "dropdown mt-1" });
const _c2 = () => ({ button: "btn btn-secondary dropdown-toggle width-180 d-flex justify-content-between", dropdownContainer: "dropdown" });
const _c3 = a0 => ({ open: a0 });
export class AttributionRelativeComponent {
    get ATTRIBUTION_BENCHMARK_CONFIG() {
        if (this.categorization !== this._lastCategorization) {
            this._lastCategorization = this.categorization;
            const isBondCategorization = this.categorization === AttributionCategorization.BOND_SECTOR ||
                this.categorization === AttributionCategorization.BOND_MATURITY;
            if (isBondCategorization) {
                this._attributionBenchmarkConfig = {
                    list: this.ATTRIBUTION_BENCHMARK_CONFIG_BASE.list.filter((option) => option.value !== AttributionBenchmarkOption.S_AND_P),
                };
            }
            else {
                this._attributionBenchmarkConfig = this.ATTRIBUTION_BENCHMARK_CONFIG_BASE;
            }
        }
        return this._attributionBenchmarkConfig;
    }
    constructor(eltRef, accountsService, featureService, securitiesService, httpClient) {
        this.eltRef = eltRef;
        this.accountsService = accountsService;
        this.featureService = featureService;
        this.securitiesService = securitiesService;
        this.httpClient = httpClient;
        this.CUSTOM_OPTION = AS_OF_DATE_CUSTOM;
        this.performancePeriodicity = PerformancePeriodicity.ONE_YEAR;
        this.benchmarkOption = AttributionBenchmarkOption.S_AND_P;
        this.categorization = AttributionCategorization.SECTOR;
        this.customBenchmarkId = '';
        this.customBenchmarkInputDisabled = true;
        this.barChartCategories = [];
        this.performanceChartData = {};
        this.performanceDisplayCategories = [];
        this.tableDisplayCategories = [];
        this.loading = true;
        this.hasExportFeature = false;
        this.exportLoading = false;
        this.errorMessage = '';
        this.fetchSubscription$ = null;
        this.asOfDateOption = AS_OF_DATE_DAILY;
        this.asOfDateConfig = AS_OF_DATE_DROPDOWN_CONFIG;
        this.useGenericDataDisplay = false;
        this.ATTRIBUTION_BENCHMARK_CONFIG_BASE = {
            list: [
                { value: AttributionBenchmarkOption.ASSIGNED, label: 'Assigned Benchmark' },
                { value: AttributionBenchmarkOption.S_AND_P, label: 'S&P 500' },
                { value: AttributionBenchmarkOption.CUSTOM, label: 'Custom Benchmark' },
            ],
        };
        this._attributionBenchmarkConfig = null;
        this._lastCategorization = null;
        this.attributioncategorizationconfig = {
            list: [
                { value: AttributionCategorization.SECTOR, label: 'Sector' },
                { value: AttributionCategorization.EQUITY_STYLE, label: 'Equity Style' },
                { value: AttributionCategorization.BROAD_ASSET_CLASS, label: 'Broad Asset Class' },
                { value: AttributionCategorization.BOND_SECTOR, label: 'Bond Sector' },
                { value: AttributionCategorization.BOND_MATURITY, label: 'Bond Maturity' },
            ],
        };
        this.securityId = this.eltRef.nativeElement.getAttribute('securityId');
        this.securityName = this.eltRef.nativeElement.getAttribute('securityName');
        this.securityType = this.eltRef.nativeElement.getAttribute('securityType');
        this.performancePeriodicity = this.eltRef.nativeElement.getAttribute('performancePeriodicity');
        this.categorization = this.eltRef.nativeElement.getAttribute('categorization');
        this.useGenericDataDisplay = this.eltRef.nativeElement.getAttribute('useGenericDataDisplay') === 'True';
        this.asOfDateOption = this.eltRef.nativeElement.getAttribute('asOfDate');
        const asOfDateCustom = this.eltRef.nativeElement.getAttribute('customDate');
        if (asOfDateCustom && this.asOfDateOption === AS_OF_DATE_CUSTOM) {
            this.asOfDateCustom = new Date(asOfDateCustom);
        }
        const benchmarkPreference = this.eltRef.nativeElement.getAttribute('benchmark');
        if (Object.values(AttributionBenchmarkOption).includes(benchmarkPreference)) {
            this.benchmarkOption = benchmarkPreference;
            if (this.benchmarkOption === AttributionBenchmarkOption.S_AND_P &&
                (this.categorization === 'bond_sector' || this.categorization === 'bond_maturity')) {
                this.benchmarkOption = AttributionBenchmarkOption.ASSIGNED;
            }
            this.customBenchmarkInputDisabled = true;
        }
        else {
            this.benchmarkOption = AttributionBenchmarkOption.CUSTOM;
            this.customBenchmarkId = benchmarkPreference;
            this.customBenchmarkInputDisabled = false;
        }
        this.hasExportFeature = this.featureService.userHasFeatures([STATIC_PDF_FEATURE]);
    }
    ngOnInit() {
        if (!window.USER.authenticated) {
            this.loading = false;
            this.errorMessage = 'Please log in to view this data.';
            return;
        }
        this.fetchSubscription$ = this.fetchAttributionData();
    }
    ngOnDestroy() {
        if (this.fetchSubscription$ !== null)
            this.fetchSubscription$.unsubscribe();
    }
    setBenchmarkOption(benchmarkOption) {
        const benchmarkOptionChanged = benchmarkOption !== this.benchmarkOption;
        this.benchmarkOption = benchmarkOption;
        this.customBenchmarkInputDisabled = this.benchmarkOption !== AttributionBenchmarkOption.CUSTOM;
        if (benchmarkOptionChanged && benchmarkOption !== AttributionBenchmarkOption.CUSTOM) {
            // Clear custom benchmark and update preferences
            this.clearCustomBenchmark();
            this.fetchAttributionData();
            if (this.securityType !== 'model_portfolio') {
                // For non-model portfolios, also update user preferences
                const preferenceName = `${this.securityType}_attribution_benchmark`;
                this.accountsService.putUserPreferences({ [preferenceName]: benchmarkOption }).subscribe();
            }
        }
        else {
            // Just clear the ID locally when switching to custom
            this.customBenchmarkId = '';
        }
    }
    setCategorization(categorization) {
        if (categorization !== this.categorization) {
            this.categorization = categorization;
            const isBondCategorization = categorization === AttributionCategorization.BOND_SECTOR ||
                categorization === AttributionCategorization.BOND_MATURITY;
            if (isBondCategorization && this.benchmarkOption === AttributionBenchmarkOption.S_AND_P) {
                this.setBenchmarkOption(AttributionBenchmarkOption.ASSIGNED);
            }
            else {
                this.fetchAttributionData();
            }
            const preferenceName = `${this.securityType}_attribution_categorization`;
            this.accountsService.putUserPreferences({ [preferenceName]: categorization }).subscribe();
        }
    }
    selectCustomBenchmark(selectedSecurity) {
        this.customBenchmarkId = selectedSecurity.search_id;
        this.fetchAttributionData();
        if (this.customBenchmarkId) {
            if (this.securityType === 'model_portfolio') {
                this.updateModelPortfolioCustomBenchmark(this.customBenchmarkId);
            }
            else {
                const preferenceName = `${this.securityType}_attribution_benchmark`;
                this.accountsService.putUserPreferences({ [preferenceName]: this.customBenchmarkId }).subscribe();
            }
        }
    }
    clearCustomBenchmark() {
        this.customBenchmarkId = '';
        if (this.securityType === 'model_portfolio') {
            this.updateModelPortfolioCustomBenchmark(null);
        }
    }
    updateModelPortfolioCustomBenchmark(benchmarkSecurityId) {
        const modelPortfolioId = this.securityId.split(':')[1];
        const url = `/model_portfolios/${modelPortfolioId}/attribution/custom_benchmark`;
        this.httpClient.put(url, { benchmark_security_id: benchmarkSecurityId }).subscribe();
    }
    updatePeriodicity(periodicity) {
        if (periodicity !== this.performancePeriodicity) {
            this.performancePeriodicity = periodicity;
            this.fetchAttributionData();
            const preferenceName = `${this.securityType}_attribution_relative_tab_zoom`;
            this.accountsService.putUserPreferences({ [preferenceName]: periodicity }).subscribe();
        }
    }
    asOfDateHandler(asOfDate) {
        if (asOfDate !== this.asOfDateOption) {
            this.asOfDateOption = asOfDate;
            if (asOfDate === AS_OF_DATE_CUSTOM && !this.asOfDateCustom) {
                return;
            }
            if (asOfDate !== AS_OF_DATE_CUSTOM) {
                this.asOfDateCustom = null;
            }
            let putParams;
            if (isPeriodicityDisabled(this.performancePeriodicity, asOfDate)) {
                this.performancePeriodicity = PerformancePeriodicity.THREE_MONTHS;
                putParams = {
                    [`${this.securityType}_attribution_relative_tab_zoom`]: this.performancePeriodicity,
                    [`${this.securityType}_attribution_relative_tab_as_of_date`]: asOfDate,
                };
            }
            else {
                putParams = {
                    [`${this.securityType}_attribution_relative_tab_as_of_date`]: asOfDate,
                    [`${this.securityType}_attribution_relative_tab_date`]: null,
                };
            }
            this.fetchAttributionData();
            this.accountsService.putUserPreferences(putParams).subscribe();
        }
    }
    dateChangeHandler(date) {
        if (date && date !== this.asOfDateCustom) {
            this.asOfDateCustom = date;
            const dateString = date ? formatDateString(date) : '';
            this.fetchAttributionData();
            const datePreferenceName = `${this.securityType}_attribution_relative_tab_date`;
            const asOfDatePreferenceName = `${this.securityType}_attribution_relative_tab_as_of_date`;
            this.accountsService
                .putUserPreferences({ [datePreferenceName]: dateString, [asOfDatePreferenceName]: AS_OF_DATE_CUSTOM })
                .subscribe();
        }
    }
    fetchAttributionData() {
        this.errorMessage = '';
        this.loading = true;
        const valFormatter = getFormatter('percent');
        const formatPercentValue = (value) => {
            return value !== null ? valFormatter(value, 2) : '--';
        };
        if (this.fetchSubscription$ !== null)
            this.fetchSubscription$.unsubscribe();
        return this.securitiesService
            .getRelativeAttributionData(this.securityId, this.performancePeriodicity, this.benchmarkOption, this.customBenchmarkId, this.categorization, this.asOfDateOption, this.asOfDateCustom ? formatDateString(this.asOfDateCustom) : '')
            .subscribe({
            next: (attributionData) => {
                // Attribution table data
                const tableDisplayCategories = [];
                // Bar Chart Data
                const barChartCategories = [];
                // Performance Chart Data
                const portfolioPerformance = [];
                const benchmarkPerformance = [];
                const categoryNames = [];
                const performanceDisplayCategories = [];
                attributionData.data.forEach((category) => {
                    tableDisplayCategories.push({
                        name: category.category_name,
                        portfolioWeight: formatPercentValue(category.portfolio_weight),
                        portfolioReturn: formatPercentValue(category.portfolio_return),
                        benchmarkWeight: formatPercentValue(category.benchmark_weight),
                        benchmarkReturn: formatPercentValue(category.benchmark_return),
                        allocation: formatPercentValue(category.allocation),
                        selection: formatPercentValue(category.selection),
                        interaction: formatPercentValue(category.interaction),
                        total: formatPercentValue(category.total),
                        totalCellColorClass: category.total ? category.total_css_class : 'bg-neutral',
                        holdings: category.holdings.map((holding) => ({
                            securityId: holding.security_id,
                            securityUrl: holding.security_url,
                            securityWeight: formatPercentValue(holding.security_weight),
                            securityReturn: formatPercentValue(holding.security_return),
                            benchmarkWeight: formatPercentValue(holding.benchmark_weight),
                            benchmarkReturn: formatPercentValue(holding.benchmark_return),
                            allocation: formatPercentValue(holding.allocation),
                            selection: formatPercentValue(holding.selection),
                            interaction: formatPercentValue(holding.interaction),
                            total: formatPercentValue(holding.total),
                        })),
                        expanded: false,
                    });
                    barChartCategories.push({
                        name: category.category_name,
                        data: [category.total],
                    });
                    portfolioPerformance.push(category.portfolio_return);
                    benchmarkPerformance.push(category.benchmark_return);
                    categoryNames.push(category.category_name);
                    performanceDisplayCategories.push({
                        name: SECTOR_DISPLAY_NAMES[category.category_name] || category.category_name,
                        portfolioReturn: formatPercentValue(category.portfolio_return),
                        benchmarkReturn: formatPercentValue(category.benchmark_return),
                        excessReturn: formatPercentValue(category.excess_return),
                        excessReturnCellCssClass: category.excess_return_css_class,
                    });
                });
                this.tableDisplayCategories = tableDisplayCategories;
                this.barChartCategories = barChartCategories;
                this.performanceChartData = {
                    categories: categoryNames,
                    chart_data: [
                        {
                            label: 'Portfolio Return',
                            data: portfolioPerformance,
                            data_type: 'percent',
                        },
                        {
                            label: 'Benchmark Return',
                            data: benchmarkPerformance,
                            data_type: 'percent',
                        },
                    ],
                    language: Language.ENGLISH,
                };
                this.performanceDisplayCategories = performanceDisplayCategories;
            },
            error: (error) => {
                this.errorMessage = error.error.error_message;
                this.tableDisplayCategories = [];
                this.barChartCategories = [];
                this.performanceChartData = {};
                this.performanceDisplayCategories = [];
                this.loading = false;
            },
            complete: () => {
                this.loading = false;
            },
        });
    }
    openPDFTitleModal() {
        this.pdfTitleModal.openModal();
    }
    export(title) {
        this.exportLoading = true;
        this.securitiesService
            .getRelativeAttributionDataExport(this.securityId, title, this.performancePeriodicity, this.benchmarkOption, this.customBenchmarkId, this.categorization, this.asOfDateOption, this.asOfDateCustom ? formatDateString(this.asOfDateCustom) : '')
            .subscribe({
            next: (response) => {
                downloadUrl(response.pdf_url);
                this.exportLoading = false;
            },
            error: () => {
                this.exportLoading = false;
            },
        });
    }
}
AttributionRelativeComponent.ɵfac = function AttributionRelativeComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AttributionRelativeComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.SecuritiesService), i0.ɵɵdirectiveInject(i4.HttpClient)); };
AttributionRelativeComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AttributionRelativeComponent, selectors: [["ycn-attribution-relative"]], viewQuery: function AttributionRelativeComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.pdfTitleModal = _t.first);
    } }, standalone: false, decls: 40, vars: 49, consts: [["pdfTitleModal", ""], ["helpModal", ""], [1, "row", "align-items-end"], [1, "col-auto", "col-md-8", "mb-2"], [1, "row"], [1, "col-auto"], [1, "label", "form-label", "form-label-thin"], [3, "changeHandler", "customCssClasses", "config", "selectedValue"], [1, "field-input-group", "field-search", "input-group", "mt-1", 3, "submitHandler", "removeHandler", "placeholder", "disableAutocompleterInput", "displayIdentifier", "buttonType", "searchType", "showRemove"], [1, "field-input-group", "field-search", "input-group", "mt-1", 3, "changeHandler", "customCssClasses", "config", "selectedValue"], [1, "col", "col-md-4", "mb-2", "d-flex", "justify-content-end", "align-items-end"], ["ycnTooltip", "", 1, "help-toggler", 3, "click", "tooltipHtml", "tooltipPlacement", "tooltipTitle"], [1, "col-auto", "align-self-end"], [1, "form-group", "dropdown", "menu-right", 3, "dateChangeHandler", "selectedDate", "inputDisabled", "datePlaceholder"], [1, "form-inline", "mt-1"], ["ycnDisabled", "", 1, "btn", "btn-secondary", 3, "click", "disabled"], ["ycnIcon", "", 3, "name"], [3, "periodicityChangeHandler", "categorization", "errorMessage", "performancePeriodicity", "displayCategories", "loading", "asOfDateOption"], [3, "periodicityChangeHandler", "errorMessage", "performancePeriodicity", "categories", "loading", "asOfDateOption"], [3, "periodicityChangeHandler", "errorMessage", "performancePeriodicity", "chartData", "displayCategories", "loading", "asOfDateOption"], [3, "submitHandler", "defaultTitle", "submitButtonText"], [3, "loadingText", "modalTrigger"]], template: function AttributionRelativeComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "div", 5)(4, "div", 6);
        i0.ɵɵtext(5, "Benchmark");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "ycn-single-select-dropdown", 7);
        i0.ɵɵlistener("changeHandler", function AttributionRelativeComponent_Template_ycn_single_select_dropdown_changeHandler_6_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setBenchmarkOption($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 5)(8, "div", 6);
        i0.ɵɵtext(9, "Custom Benchmark Security");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "ycn-security-autocomplete-in-place", 8);
        i0.ɵɵlistener("submitHandler", function AttributionRelativeComponent_Template_ycn_security_autocomplete_in_place_submitHandler_10_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectCustomBenchmark($event)); })("removeHandler", function AttributionRelativeComponent_Template_ycn_security_autocomplete_in_place_removeHandler_10_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.clearCustomBenchmark()); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "div", 5)(12, "div", 6);
        i0.ɵɵtext(13, "View Attribution by");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "ycn-single-select-dropdown", 9);
        i0.ɵɵlistener("changeHandler", function AttributionRelativeComponent_Template_ycn_single_select_dropdown_changeHandler_14_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.setCategorization($event)); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(15, "div", 10)(16, "div", 4)(17, "div", 5)(18, "div", 6);
        i0.ɵɵtext(19, "As of\u00A0");
        i0.ɵɵelementStart(20, "span", 11);
        i0.ɵɵlistener("click", function AttributionRelativeComponent_Template_span_click_20_listener() { i0.ɵɵrestoreView(_r1); const helpModal_r2 = i0.ɵɵreference(39); return i0.ɵɵresetView(helpModal_r2.openModal("mp_creator_as_of_date")); });
        i0.ɵɵtext(21, "(?)");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(22, "ycn-single-select-dropdown", 7);
        i0.ɵɵlistener("changeHandler", function AttributionRelativeComponent_Template_ycn_single_select_dropdown_changeHandler_22_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.asOfDateHandler($event)); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(23, "div", 12)(24, "ycn-single-date-picker", 13);
        i0.ɵɵlistener("dateChangeHandler", function AttributionRelativeComponent_Template_ycn_single_date_picker_dateChangeHandler_24_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.dateChangeHandler($event)); });
        i0.ɵɵtext(25, "> ");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(26, "div", 12)(27, "div", 14)(28, "button", 15);
        i0.ɵɵlistener("click", function AttributionRelativeComponent_Template_button_click_28_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.openPDFTitleModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(29, "svg", 16);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(30, "span");
        i0.ɵɵtext(31, "Export");
        i0.ɵɵelementEnd()()()()()()();
        i0.ɵɵelementStart(32, "ycn-attribution-relative-table", 17);
        i0.ɵɵlistener("periodicityChangeHandler", function AttributionRelativeComponent_Template_ycn_attribution_relative_table_periodicityChangeHandler_32_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updatePeriodicity($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "ycn-attribution-bar-chart", 18);
        i0.ɵɵlistener("periodicityChangeHandler", function AttributionRelativeComponent_Template_ycn_attribution_bar_chart_periodicityChangeHandler_33_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updatePeriodicity($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "ycn-attribution-performance-chart", 19);
        i0.ɵɵlistener("periodicityChangeHandler", function AttributionRelativeComponent_Template_ycn_attribution_performance_chart_periodicityChangeHandler_34_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.updatePeriodicity($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(35, "ycn-pdf-title-modal", 20, 0);
        i0.ɵɵlistener("submitHandler", function AttributionRelativeComponent_Template_ycn_pdf_title_modal_submitHandler_35_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.export($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(37, "ycn-loading-modal", 21)(38, "ycn-help-modal", null, 1);
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(44, _c1))("config", ctx.ATTRIBUTION_BENCHMARK_CONFIG)("selectedValue", ctx.benchmarkOption);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("placeholder", "Security")("disableAutocompleterInput", ctx.customBenchmarkInputDisabled)("displayIdentifier", ctx.customBenchmarkId)("buttonType", "icon-search")("searchType", "securities_with_holdings")("showRemove", true);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(45, _c2))("config", ctx.attributioncategorizationconfig)("selectedValue", ctx.categorization);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("tooltipHtml", true)("tooltipPlacement", "bottom")("tooltipTitle", "Help");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(46, _c1))("config", ctx.asOfDateConfig)("selectedValue", ctx.asOfDateOption);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("selectedDate", ctx.asOfDateCustom)("inputDisabled", ctx.asOfDateOption !== ctx.CUSTOM_OPTION)("datePlaceholder", "MM/DD/YYYY");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("disabled", !ctx.hasExportFeature);
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-export");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("categorization", ctx.categorization)("errorMessage", ctx.errorMessage)("performancePeriodicity", ctx.performancePeriodicity)("displayCategories", ctx.tableDisplayCategories)("loading", ctx.loading)("asOfDateOption", ctx.asOfDateOption);
        i0.ɵɵadvance();
        i0.ɵɵproperty("errorMessage", ctx.errorMessage)("performancePeriodicity", ctx.performancePeriodicity)("categories", ctx.barChartCategories)("loading", ctx.loading)("asOfDateOption", ctx.asOfDateOption);
        i0.ɵɵadvance();
        i0.ɵɵproperty("errorMessage", ctx.errorMessage)("performancePeriodicity", ctx.performancePeriodicity)("chartData", ctx.performanceChartData)("displayCategories", ctx.performanceDisplayCategories)("loading", ctx.loading)("asOfDateOption", ctx.asOfDateOption);
        i0.ɵɵadvance();
        i0.ɵɵproperty("defaultTitle", ctx.securityName + " Attribution Analysis")("submitButtonText", "Download");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("loadingText", "Exporting PDF")("modalTrigger", i0.ɵɵpureFunction1(47, _c3, ctx.exportLoading));
    } }, dependencies: [i5.SecurityAutocompleteInPlaceComponent, i6.DisabledDirective, i7.HelpModalComponent, i8.IconDirective, i9.LoadingModalComponent, i10.PdfTitleModalComponent, i11.SingleDatePickerComponent, i12.SingleSelectDropdownComponent, i13.TooltipDirective, i14.AttributionBarChartComponent, i15.AttributionPerformanceChartComponent, i16.AttributionRelativeTableComponent], encapsulation: 2 });
